import { createSelector } from 'reselect'

const pusherEventStatesSelector = (state) => state.pusher.eventStates

export const selectPusherEventStates = createSelector(
  [pusherEventStatesSelector],
  (pusherEventStates) => {
    return { pusherEventStates }
  },
)
